class ServicesController {
  constructor($stateParams, $timeout) {
    "ngInject";
    this.name = 'services';

    $(document).ready(function() {
      let anchor = $stateParams.anchor;

      if(anchor != null){
        $timeout(function() {
          $("html,body").animate({
            scrollTop: $("#" + anchor).offset().top - 70
          }, 1000);
        }, 200);
      }
    });

  }



}

export default ServicesController;



// WEBPACK FOOTER //
// ./app/components/services/services.controller.js